module.exports = __webpack_public_path__ + "img/slogan-fail.8a44e416.png";